// src/pages/Dashboard.js
import React, { useState, useEffect } from 'react';
import "react-datetime/css/react-datetime.css";
import "moment/locale/en-gb"; // Import locale (change to your preferred locale)
import ContractTable from './components/ContractTable';
import UpdateContact from './components/UpdateContact';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

moment.updateLocale("en-gb", {
    week: {
        dow: 1,
    },
});

const Contract = () => {

    const navigate = useNavigate();

    const handleClickedLogout = async (e) => {
        // Clear the token from local storage
        localStorage.removeItem("token");
        navigate('/login');
    }

    const [tabs, setTabs] = useState([
        { name: 'Embarkation Ladder', type: "embed_ladder_contracts", current: false },
        { name: 'Pilot Ladder', type: "pilot_ladder_contracts", current: true },
    ])

    const [newContract, setNewContract] = useState({
        serial_number: '',
        length: '',
        ship_name: '',
        company_name: '',
        expiry_date: "27-03-2031",
        year_of_construction: "27-03-2026",
        file_name: '',
        file_url: '',
        date: moment().format("DD.MM.YYYY"),
        extension_rope: '',
        place: '',
        contract_type: tabs.find((t) => t.current == true).type,
    })

    const [newContractAdded, setNewContractAdded] = useState(false);
    const [openUpdateContractModal, setOpenUpdateContractModal] = useState(false);
    const [contracts, setContracts] = useState([]);

    async function fetchContracts(type) {
        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/contracts/${type}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            });

            if (!response.ok) {
                throw new Error("Failed to fetch contracts");
            }
            const contractsResult = await response.json();
            if (contractsResult.length > 0) {
                let maxNum = 0;
                contractsResult.forEach(c => {
                    const num = parseInt(c.serial_number);
                    if (!isNaN(num) && num > maxNum) {
                        maxNum = num;
                    }
                });
                setNewContract(prev => ({
                    ...prev,
                    serial_number: `${(maxNum + 1).toString().padStart(4, '0')}`,
                }));
            } else {
                setNewContract(prev => ({
                    ...prev,
                    serial_number: `0001`,
                }));
            }
            setContracts(contractsResult);
        } catch (error) {
            console.error("Error fetching contracts:", error);
        }
    }

    const handleChangeContractType = (myTab) => {
        setTabs(tabs.map(tab => ({
            ...tab,
            current: tab.name === myTab.name
        })));

    }

    useEffect(() => {
        fetchContracts(tabs.find((t) => t.current == true).type);
        setNewContractAdded(false);
    }, [tabs, newContractAdded]);

    return (
        <div className='relative bg-gray-100 h-[100vh] overflow-hidden'>
            <div className="w-full flex flex-col items-center bg-white text-black rounded-md">
                <nav aria-label="Tabs" className="flex  space-x-4 cursor-pointer">
                    {tabs && tabs.map((tab) => (
                        <a
                            key={tab.name}
                            href={tab.href}
                            onClick={() => handleChangeContractType(tab)}
                            aria-current={tab.current ? 'page' : undefined}
                            className={`${tab.current && "underline decoration-teal-950"} text-gray-500 hover:text-gray-700 rounded-md px-3 py-2 text-sm font-medium`
                            }
                        >
                            {tab.name}
                        </a>
                    ))}
                    <a href="#" onClick={(e) => { handleClickedLogout() }} className="text-red-500 hover:text-red-700 rounded-md px-3 py-2 text-sm font-bold">Logout</a>
                </nav>
            </div>
            <button
                onClick={(e) => { setOpenUpdateContractModal(true) }}
                type="button"
                className="m-2 rounded bg-indigo-600 px-2 py-1 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
                <span className='text-lg pr-1 '>+</span> Create New
            </button>
            {contracts && <ContractTable setNewContractAdded={setNewContractAdded} contracts={contracts} tab={tabs.find((t) => t.current == true)} />}
            {openUpdateContractModal && <UpdateContact
                isNewContract={true}
                openModal={() => { setOpenUpdateContractModal(false) }}
                updateContract={newContract}
                tab={tabs.find((t) => t.current == true)}
                setNewContractAdded={setNewContractAdded}
            />}

        </div>



    );
};


export default Contract;
